import posthog from "posthog-js";

// Route ingestion AND assets through a first-party PostHog reverse proxy so
// ad-blockers don't drop them. Each board points at its own proxy subdomain
// (`e.tmua.fyi` / `e.esat.fyi`) — both are custom domains on the one Railway
// nginx proxy (https://posthog.com/docs/advanced/proxy/railway,
// POSTHOG_CLOUD_REGION=us), which forwards `/static/*` to the asset CDN with the
// correct upstream Host + SNI.
//
// Why the dedicated proxy (not the `/ph` Next.js rewrite): the rewrite can't set
// the upstream Host, so the asset CDN 403s `/ph/static/recorder.js` in prod and
// the session recorder never loads (replays come back empty). Resolved per host
// at runtime because one build serves both boards; localhost / previews fall
// back to the built-in `/ph` rewrite.
const PROXY_APEXES = ["tmua.fyi", "esat.fyi"];

function posthogApiHost(): string {
  if (typeof window === "undefined") return "/ph";
  const host = window.location.hostname;
  const apex = PROXY_APEXES.find((a) => host === a || host.endsWith(`.${a}`));
  return apex ? `https://e.${apex}` : "/ph";
}

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: posthogApiHost(),
  ui_host: "https://us.posthog.com",
  defaults: "2025-05-24",
  capture_exceptions: true, // This enables capturing exceptions using Error Tracking
  debug: process.env.NODE_ENV === "development",
});

declare global {
  interface Window {
    posthog?: typeof posthog;
  }
}

// Console access in dev, e.g. to override experiment flags:
// posthog.featureFlags.overrideFeatureFlags({ flags: { "lifetime-price-test": "price-90" } })
if (process.env.NODE_ENV === "development") {
  window.posthog = posthog;
}
